import React from 'react';
import { ColorRing } from 'react-loader-spinner';

const Lodderr = () => {
  return (
   
    <div className="loader-container">
    <div className="loader"></div>
  </div>

 
  );
};

export default Lodderr;
 